(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[719],{

/***/ "x5wo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NavigationLargePanel", function() { return NavigationLargePanel; });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("zjfJ");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("TSYQ");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Navigation_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("1cDg");

var __jsx = react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




var NavigationLargePanel = /*#__PURE__*/Object(react__WEBPACK_IMPORTED_MODULE_1__["forwardRef"])(function (_ref, ref) {
  var children = _ref.children,
      isActive = _ref.isActive;

  if (!react__WEBPACK_IMPORTED_MODULE_1__["Children"].count(children)) {
    return null;
  }

  return __jsx("div", {
    className: "absolute inset-x-0 pointer-events-none top-full z-0"
  }, __jsx("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()('max-w-site mx-auto my-0 overflow-hidden transition-none w-full', {
      'absolute rtl:left-outOfBounds opacity-0 pointer-events-none': !isActive,
      'opacity-100 pointer-events-auto': isActive
    }),
    "data-testid": "NavigationLarge-subItems",
    ref: ref,
    style: _objectSpread({
      maxHeight: _Navigation_constants__WEBPACK_IMPORTED_MODULE_3__[/* NAVIGATIONLARGE_SUBNAV_MAX_HEIGHT */ "a"]
    }, isActive ? {
      transition: 'opacity ease-in 0.4s 0.2s'
    } : null)
  }, children));
});

/***/ })

}]);